import queryString from 'query-string';
import ua from '../../ua';
import { LocalStorage } from '../../shared/utils';
import TYPES from '../action-types';

const isMobile = ua.browser.isNotDesktop();
let openedTree = JSON.parse(localStorage.getItem('picsio.treeOpened'));
const isDetailsOpen = JSON.parse(localStorage.getItem('picsio.detailsOpened'));
if (!openedTree && isMobile) {
  openedTree = 'collections';
}

export const MIN_WIDTH_LEFT_PANEL = 300;
export const MIN_WIDTH_RIGHT_PANEL = 350;
export const MIN_WIDTH_MULTI_PAGE_PANEL = 100;

const params = queryString.parse(window.location.search);

const defaultState = {
  openedTree: openedTree === null ? 'collections' : openedTree,
  previousOpenedTree: JSON.parse(localStorage.getItem('picsio.previousOpenedTree')),
  isDetailsOpen: isDetailsOpen === null ? true : isDetailsOpen,
  treeWidth: JSON.parse(localStorage.getItem('picsio.treeWidth')) || `${MIN_WIDTH_LEFT_PANEL}px`,
  catalogViewMode: JSON.parse(localStorage.getItem('picsio.catalogViewMode')) || 'grid',
  bulkMediaMatchViewMode: params?.isMediaMatch ? true : JSON.parse(localStorage.getItem('picsio.bulkMediaMatchViewMode')) || false,
  catalogViewItemSize: parseFloat(localStorage.getItem('picsio.catalogViewItemSize')) || null,
  importOpened: false,
  backlight: false,
  panelsWidth: JSON.parse(localStorage.getItem('picsio.panelsWidth')) || {
    catalogView: { left: MIN_WIDTH_LEFT_PANEL, right: MIN_WIDTH_RIGHT_PANEL },
    previewView: { right: MIN_WIDTH_RIGHT_PANEL },
  },
  downloadListOpened: false,
  mapViewport: null,
  assetScale: 1,
  mobileAdditionalPanelActive: 'Home',
  mobileMainScreenPanelActive: 'catalog',
  mobileMainScreenSlideWidth: 0,
  isWebpSupported: true,
  isVisualSearchBannerHidden: localStorage.getItem('visualSearchBannerHidden'),
  isBulkAiProcessingDialogHidden: LocalStorage.get('isBulkAiProcessingDialogHidden'),
};

export default function (state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
  case TYPES.MAIN.CHANGE_TREE: {
    return {
      ...state,
      previousOpenedTree: state.openedTree,
      importOpened: false,
      openedTree: payload.name,
      downloadListOpened: false,
    };
  }

  case TYPES.MAIN.RESIZE_PANEL: {
    return {
      ...state,
      panelsWidth: payload.panelsWidth,
    };
  }

  case TYPES.MAIN.RECALCULATE_PANEL_SIZE: {
    return {
      ...state,
      panelsWidth: payload.newPanelsWidth,
    };
  }

  case TYPES.MAIN.CHANGE_CATALOG_VIEW_MODE: {
    return {
      ...state,
      catalogViewMode: payload.type,
      catalogViewItemSize: null,
    };
  }

  case TYPES.MAIN.CHANGE_BULK_MEDIA_MATCH_VIEW_MODE: {
    return {
      ...state,
      bulkMediaMatchViewMode: payload,
      catalogViewMode: payload ? 'list' : JSON.parse(localStorage.getItem('picsio.catalogViewMode')) || 'grid',
    };
  }

  case TYPES.MAIN.CHANGE_CATALOG_VIEW_MODE_SIZE: {
    return {
      ...state,
      catalogViewItemSize: payload.size,
    };
  }

  case TYPES.MAIN.OPEN_DETAILS: {
    return {
      ...state,
      isDetailsOpen: payload.status,
    };
  }

  case TYPES.MAIN.CLOSE_DETAILS: {
    return {
      ...state,
      isDetailsOpen: payload.status,
    };
  }

  case TYPES.MAIN.OPEN_IMPORT: {
    return {
      ...state,
      importOpened: true,
      downloadListOpened: false,
    };
  }

  case TYPES.MAIN.CLOSE_IMPORT: {
    return {
      ...state,
      importOpened: false,
    };
  }

  case TYPES.MAIN.SET_BACKLIGHT: {
    return {
      ...state,
      backlight: payload.value,
    };
  }

  case TYPES.MAIN.OPEN_DOWNLOADLIST: {
    return {
      ...state,
      downloadListOpened: true,
    };
  }

  case TYPES.MAIN.CLOSE_DOWNLOADLIST: {
    return {
      ...state,
      downloadListOpened: false,
    };
  }

  case TYPES.MAIN.SET_IS_WEBP_SUPPORTED: {
    return {
      ...state,
      isWebpSupported: payload.isSupported,
    };
  }

  case TYPES.MAIN.SET_MAP_VIEWPORT: {
    return {
      ...state,
      mapViewport: payload.viewport ? { ...payload.viewport } : null,
    };
  }

  case TYPES.MAIN.SET_ASSET_SCALE: {
    return {
      ...state,
      assetScale: payload.scale,
    };
  }

  case TYPES.MAIN.SET_MOBILE_MAIN_SCREEN: {
    return {
      ...state,
      mobileMainScreenPanelActive: payload.mobileMainScreenPanelActive,
      mobileMainScreenSlideWidth: payload.mobileMainScreenSlideWidth,
    };
  }

  case TYPES.MAIN.SET_MOBILE_ADDITIONAL_SCREEN: {
    return {
      ...state,
      mobileAdditionalPanelActive: payload.mobileAdditionalPanelActive,
    };
  }

  case TYPES.MAIN.SET_VISUAL_SEARCH_BANNER_STATE: {
    return {
      ...state,
      isVisualSearchBannerHidden: payload,
    };
  }

  case TYPES.MAIN.SET_SHOW_BULK_PROCESSING_DIALOG: {
    return {
      ...state,
      isBulkAiProcessingDialogHidden: payload,
    };
  }

  /* Default */
  default: {
    return state;
  }
  }
}
